import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PERIODICOS_LOTES_TABS_INDEX {
    PENDIENTE_PRESTADOR = 0,
    EN_CURSO = 1,
    CERRADOS = 2
}

interface PeriodicosInitialState {
    currentBatchesTab: number;
}

const initialState: PeriodicosInitialState = {
    currentBatchesTab: PERIODICOS_LOTES_TABS_INDEX.PENDIENTE_PRESTADOR
};

const periodicosSlice = createSlice({
    name: 'periodicos',
    initialState,
    reducers: {
        setCurrentBatchesTab: (state, action: PayloadAction<number | null>) => {
            state.currentBatchesTab = action.payload ?? PERIODICOS_LOTES_TABS_INDEX.PENDIENTE_PRESTADOR;
        }
    }
});

export const { setCurrentBatchesTab } = periodicosSlice.actions;
export default periodicosSlice.reducer;
